// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__FacuN","shimmer":"skeleton_shimmer__afxHL"};